import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { FUTURE_PUBLICATIONS } from '../data/site';
import { AgreexaMark } from './AgreexaMark';
export function EcosystemDiagram() {
  return <div className="flex flex-col items-center text-center" data-id="element-59">
      {/* Parent */}
      <div className="rounded-sm bg-ink text-paper px-10 py-6" data-id="element-60">
        <p className="eyebrow text-stone-400 mb-1" style={{
        fontSize: '0.6rem'
      }} data-id="element-61">
          The Global Trust Infrastructure
        </p>
        <AgreexaMark tone="light" className="text-2xl" data-id="element-62" />
      </div>

      <ArrowDownIcon className="h-6 w-6 text-stone-400 my-4" aria-hidden="true" data-id="element-63" />

      {/* Flagship */}
      <div className="rounded-sm border-2 border-trust-500 bg-trust-50 px-8 py-5" data-id="element-64">
        <p className="eyebrow text-trust-600 mb-1" style={{
        fontSize: '0.6rem'
      }} data-id="element-65">
          Flagship Publication
        </p>
        <p className="font-serif text-xl tracking-tightest text-ink" style={{
        fontWeight: 600
      }} data-id="element-66">
          Home Independence Hub™
        </p>
      </div>

      <ArrowDownIcon className="h-6 w-6 text-stone-400 my-4" aria-hidden="true" data-id="element-67" />

      <p className="eyebrow text-stone-500 mb-5" data-id="element-68">Future Publications</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 w-full max-w-2xl" data-id="element-69">
        {FUTURE_PUBLICATIONS.map(pub => <div key={pub.name} className="rounded-sm border border-dashed border-stone-300 bg-white/60 px-4 py-4" data-id="element-70">
            <p className="text-sm font-600 text-stone-700" data-id="element-71">{pub.name}</p>
            <p className="text-[0.65rem] eyebrow text-stone-400 mt-1" data-id="element-72">
              Coming Soon
            </p>
          </div>)}
      </div>
    </div>;
}